module.exports = __webpack_public_path__ + "static/media/LTC-BUSD.8c79042b.png";